import React from 'react'
import PropTypes from 'prop-types'
import StyledPill from './Pills.styles'

const Pill = ({ label, className, href, target, active, disabled, onClick, 'data-test': dataTest, ...props }) => (
  <StyledPill
    className={className}
    href={!disabled ? href || '' : undefined}
    target={target}
    active={active}
    disabled={disabled}
    onClick={onClick}
    tabIndex={!disabled ? 0 : undefined}
    data-test={`${dataTest}${active ? '--active' : ''}`}
    {...props}>
    {label}
  </StyledPill>
)

Pill.propTypes = {
  /**
   * Required text content of the Pill
   */
  label: PropTypes.string.isRequired,

  /**
   * Optional flag indicating if the pill is in the active state
   */
  active: PropTypes.bool,

  /**
   * Optional flag indicating if the pill is in the disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Optional link for the Pill
   */
  href: PropTypes.string,

  /**
   * Optional definition of where to open the linked document
   */
  target: PropTypes.string,

  /**
   * Optional function to be called when Pill is clicked
   */
  onClick: PropTypes.func,

  /**
   * Specify an optional data-test attribute to be added to your Pill component for e2e testing
   */
  'data-test': PropTypes.string
}

Pill.defaultProps = {
  target: '_self',
  active: false,
  disabled: false,
  onClick: /* istanbul ignore next */ () => {},
  'data-test': 'component-pill'
}

export default Pill
